// ============================================================
// Çevrimdışı durum ve uygulama güncellemesi (§1)
//
// Öğretmen bahçede tabletle yoklama alıyor ve orada ağ çekmiyor.
// İki şeyi görünür kılmak zorundayız:
//   1. Şu an çevrimdışı mıyız?
//   2. Bekleyen kaç değişiklik var?
//
// "Kaydedildi" diye gösterip aslında hiçbir yere gitmemiş olmak,
// çevrimdışı çalışmamaktan daha kötüdür.
// ============================================================

import { gunlukBoyu } from "../repo/index.js";

const durum = {
  cevrimici: typeof navigator === "undefined" ? true : navigator.onLine,
  // Çevrimdışına düşüldüğü andaki günlük boyu; fark bekleyen yazma sayısıdır.
  cevrimdisiBaslangic: null,
  guncellemeHazir: false,
  guncelle: null,
};

export const cevrimici = () => durum.cevrimici;
export const guncellemeHazir = () => durum.guncellemeHazir;

/** Çevrimdışı kalınan sürede biriken değişiklik sayısı. */
export function bekleyenYazma() {
  if (durum.cevrimici || durum.cevrimdisiBaslangic == null) return 0;
  return Math.max(0, gunlukBoyu() - durum.cevrimdisiBaslangic);
}

/**
 * Ağ durumunu ve service worker güncellemesini dinler.
 * @param {() => void} tazele  durum değişince arayüzü yeniden çizer
 */
export function agiDinle(tazele) {
  if (typeof window === "undefined") return;

  const degisti = () => {
    const onceki = durum.cevrimici;
    durum.cevrimici = navigator.onLine;

    if (onceki && !durum.cevrimici) durum.cevrimdisiBaslangic = gunlukBoyu();
    if (!onceki && durum.cevrimici) durum.cevrimdisiBaslangic = null;

    tazele();
  };

  window.addEventListener("online", degisti);
  window.addEventListener("offline", degisti);
}

/** Service worker güncelleme istemini bağlar (vite-plugin-pwa). */
export async function guncellemeyiDinle(tazele) {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  try {
    const { registerSW } = await import("virtual:pwa-register");
    durum.guncelle = registerSW({
      immediate: true,
      onNeedRefresh() { durum.guncellemeHazir = true; tazele(); },
    });
  } catch {
    // Geliştirme ortamında sanal modül yok — sessizce geç.
  }
}

/** Kullanıcı "Yenile" dediğinde yeni sürüme geçer. */
export function guncellemeyiUygula() {
  durum.guncellemeHazir = false;
  if (durum.guncelle) durum.guncelle(true);
  else location.reload();
}

/** Test kancası. */
export function durumuAyarla(yeni) {
  Object.assign(durum, yeni);
}
